import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { FaUserCircle } from 'react-icons/fa'; // Importing icons
import { FaCalendarDays } from 'react-icons/fa6';

import { Link } from 'react-router-dom'; // Importing Link for navigation




const Blog = ({ blog }) => {

  const { id, image, date, heading, admin, category } = blog; // Extracting data from blog
  const { day, shortMonth, year } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      <div className='image'>
        <img src={image} alt={heading} /> {/* Blog image */}
      </div>

      <div className='content'>

        {/* Blog category with navigation link */}
        <Link className='category' to={`/Blogs/category/${category}`}>{category}</Link>

        {/* Blog Title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        <div className='details'>

          {/* Blog Admin */}
          <h3>
            <div className='icon'><FaUserCircle /></div>
            <span>By {admin}</span>
          </h3>

          {/* Blog Date */}
          <h3>
            <div className='icon'><FaCalendarDays /></div>
            <span>{day} {shortMonth}, {year}</span>
          </h3>

        </div>

      </div>

    </div>
  );
};

export default Blog;